// extracted by mini-css-extract-plugin
export var csatScore = "_nk-5";
export var header = "_nk-1";
export var panelWrapper = "_nk-2";
export var postPreview = "_nk-3";
export var rightContent = "_nk-0";
export var wrappingText = "_nk-4";